import { defineMessages } from 'react-intl';

/** The upload dialog of a song (SoundCloud connector design c3, c4, c5). */
export const soundCloudUploadMessages = defineMessages({
  title: { id: 'app.sml.soundcloud.upload.title', defaultMessage: 'Upload to SoundCloud' },
  songLine: { id: 'app.sml.soundcloud.upload.songLine', defaultMessage: '{title} · {artist}' },
  goesTo: { id: 'app.sml.soundcloud.upload.goesTo', defaultMessage: 'Goes to' },
  changeInCatalog: { id: 'app.sml.soundcloud.upload.changeInCatalog', defaultMessage: 'Change in Catalog' },
  fieldTitle: { id: 'app.sml.soundcloud.upload.fieldTitle', defaultMessage: 'Title' },
  fieldArtist: { id: 'app.sml.soundcloud.upload.fieldArtist', defaultMessage: 'Artist' },
  withIt: { id: 'app.sml.soundcloud.upload.withIt', defaultMessage: 'What goes with it' },
  factAudio: { id: 'app.sml.soundcloud.upload.fact.audio', defaultMessage: 'Audio' },
  factAudioValue: { id: 'app.sml.soundcloud.upload.fact.audioValue', defaultMessage: '{file} · the original master' },
  factCover: { id: 'app.sml.soundcloud.upload.fact.cover', defaultMessage: 'Cover' },
  factCoverValue: { id: 'app.sml.soundcloud.upload.fact.coverValue', defaultMessage: 'The song cover' },
  factIsrc: { id: 'app.sml.soundcloud.upload.fact.isrc', defaultMessage: 'ISRC' },
  factRelease: { id: 'app.sml.soundcloud.upload.fact.release', defaultMessage: 'Release' },
  factsHint: {
    id: 'app.sml.soundcloud.upload.factsHint',
    defaultMessage: 'Change these on the song page. MUSIC24 sends them as they are now.',
  },
  whoCanListen: { id: 'app.sml.soundcloud.upload.whoCanListen', defaultMessage: 'Who can listen' },
  public: { id: 'app.sml.soundcloud.upload.public', defaultMessage: 'Public' },
  publicHint: { id: 'app.sml.soundcloud.upload.publicHint', defaultMessage: 'Everybody on SoundCloud.' },
  private: { id: 'app.sml.soundcloud.upload.private', defaultMessage: 'Private' },
  privateHint: { id: 'app.sml.soundcloud.upload.privateHint', defaultMessage: 'Only people with the link.' },
  when: { id: 'app.sml.soundcloud.upload.when', defaultMessage: 'When does it go up?' },
  whenNow: { id: 'app.sml.soundcloud.upload.when.now', defaultMessage: 'Now' },
  whenNowPublic: {
    id: 'app.sml.soundcloud.upload.when.nowPublic',
    defaultMessage: 'MUSIC24 uploads it now. It is public at once.',
  },
  whenNowPrivate: {
    id: 'app.sml.soundcloud.upload.when.nowPrivate',
    defaultMessage: 'MUSIC24 uploads it now. Only people with the link can listen.',
  },
  whenReleaseDay: { id: 'app.sml.soundcloud.upload.when.releaseDay', defaultMessage: 'On release day ({date})' },
  whenReleaseDayHint: {
    id: 'app.sml.soundcloud.upload.when.releaseDayHint',
    defaultMessage: 'MUSIC24 uploads it on {date} at 00:00 in your time zone.',
  },
  whenLater: { id: 'app.sml.soundcloud.upload.when.later', defaultMessage: 'Later' },
  whenLaterHint: {
    id: 'app.sml.soundcloud.upload.when.laterHint',
    defaultMessage: 'Pick a date and a time, at least 15 minutes from now.',
  },
  whenPick: { id: 'app.sml.soundcloud.upload.when.pick', defaultMessage: 'The date and the time' },
  noSchedule: {
    id: 'app.sml.soundcloud.upload.noSchedule',
    defaultMessage:
      'SoundCloud has no scheduled release on a free account. MUSIC24 keeps the file and uploads it at that time. Until then nothing is on SoundCloud.',
  },
  description: { id: 'app.sml.soundcloud.upload.description', defaultMessage: 'Description' },
  descriptionHint: {
    id: 'app.sml.soundcloud.upload.descriptionHint',
    defaultMessage: 'SoundCloud shows this under the track.',
  },
  footNote: {
    id: 'app.sml.soundcloud.upload.footNote',
    defaultMessage: 'MUSIC24 sends the original master, not the play copy. It uses no credits.',
  },
  notNow: { id: 'app.sml.soundcloud.upload.notNow', defaultMessage: 'Not now' },
  goNow: { id: 'app.sml.soundcloud.upload.go.now', defaultMessage: 'Upload now' },
  goReleaseDay: { id: 'app.sml.soundcloud.upload.go.releaseDay', defaultMessage: 'Upload on release day' },
  goLater: { id: 'app.sml.soundcloud.upload.go.later', defaultMessage: 'Upload at {time}' },
  goLaterNoTime: { id: 'app.sml.soundcloud.upload.go.laterNoTime', defaultMessage: 'Upload later' },
  // Errors under the button (c3 note)
  errorTooSoon: {
    id: 'app.sml.soundcloud.upload.error.tooSoon',
    defaultMessage: 'Pick a time at least 15 minutes from now.',
  },
  errorNotConnected: {
    id: 'app.sml.soundcloud.upload.error.notConnected',
    defaultMessage: 'Connect SoundCloud first.',
  },
  errorNotEnabled: {
    id: 'app.sml.soundcloud.upload.error.notEnabled',
    defaultMessage: 'Auto upload is not on for this workspace.',
  },
  errorAlreadyLive: {
    id: 'app.sml.soundcloud.upload.error.alreadyLive',
    defaultMessage: 'This song is already on SoundCloud.',
  },
  errorGeneric: { id: 'app.sml.soundcloud.upload.error.generic', defaultMessage: 'That did not work. Try again.' },
  // The master check (c5)
  masterMissing: {
    id: 'app.sml.soundcloud.upload.master.missing',
    defaultMessage: 'This song has no master file. Add the master on the song page, then upload.',
  },
  masterProcessing: {
    id: 'app.sml.soundcloud.upload.master.processing',
    defaultMessage: 'The master is still processing. Upload opens by itself when it is ready. It takes 1 to 2 minutes.',
  },
  masterFailed: {
    id: 'app.sml.soundcloud.upload.master.failed',
    defaultMessage: 'MUSIC24 could not read the master. Upload the file again on the song page.',
  },
  openSongPage: { id: 'app.sml.soundcloud.upload.openSongPage', defaultMessage: 'Open the song page' },
  upload: { id: 'app.sml.soundcloud.upload.upload', defaultMessage: 'Upload' },
  connectFirst: {
    id: 'app.sml.soundcloud.upload.connectFirst',
    defaultMessage: 'Connect SoundCloud to upload this song. You come back here after the sign-in.',
  },
  connect: { id: 'app.sml.soundcloud.upload.connect', defaultMessage: 'Connect SoundCloud' },
  reconnect: { id: 'app.sml.soundcloud.upload.reconnect', defaultMessage: 'Reconnect SoundCloud' },
  close: { id: 'app.sml.soundcloud.upload.close', defaultMessage: 'Close' },
});

/** The status panel of a SoundCloud upload (design c6). */
export const soundCloudStatusMessages = defineMessages({
  waitingHead: { id: 'app.sml.soundcloud.status.waiting.head', defaultMessage: 'Goes to SoundCloud on {date}' },
  waitingSub: {
    id: 'app.sml.soundcloud.status.waiting.sub',
    defaultMessage: '{sharing} · MUSIC24 uploads it at {time}',
  },
  waitingBody: {
    id: 'app.sml.soundcloud.status.waiting.body',
    defaultMessage: 'Nothing is on SoundCloud before that time.',
  },
  uploadingHead: { id: 'app.sml.soundcloud.status.uploading.head', defaultMessage: 'Uploading to SoundCloud' },
  uploadingBody: {
    id: 'app.sml.soundcloud.status.uploading.body',
    defaultMessage: 'You can close this. The upload goes on.',
  },
  liveHead: { id: 'app.sml.soundcloud.status.live.head', defaultMessage: 'On SoundCloud' },
  liveSub: { id: 'app.sml.soundcloud.status.live.sub', defaultMessage: 'Public since {date}' },
  liveBody: {
    id: 'app.sml.soundcloud.status.live.body',
    defaultMessage: 'Your SmartLink now has the SoundCloud link.',
  },
  privateHead: { id: 'app.sml.soundcloud.status.private.head', defaultMessage: 'Private on SoundCloud' },
  privateSub: { id: 'app.sml.soundcloud.status.private.sub', defaultMessage: 'Since {date}' },
  privateBody: {
    id: 'app.sml.soundcloud.status.private.body',
    defaultMessage: 'Only people with this link can listen. Make it public on SoundCloud.',
  },
  removedHead: { id: 'app.sml.soundcloud.status.removed.head', defaultMessage: 'Removed from SoundCloud' },
  removedSub: { id: 'app.sml.soundcloud.status.removed.sub', defaultMessage: 'Seen on {date}' },
  removedBody: {
    id: 'app.sml.soundcloud.status.removed.body',
    defaultMessage: 'SoundCloud no longer has this track. Someone deleted it or made it private on SoundCloud.',
  },
  failedHead: { id: 'app.sml.soundcloud.status.failed.head', defaultMessage: 'SoundCloud upload failed' },
  failedBody: { id: 'app.sml.soundcloud.status.failed.body', defaultMessage: 'The upload did not finish. Try again.' },
  refusedBody: {
    id: 'app.sml.soundcloud.status.refused.body',
    defaultMessage: 'SoundCloud refused the file. {detail}',
  },
  unsureBody: {
    id: 'app.sml.soundcloud.status.unsure.body',
    defaultMessage: 'The upload broke after the file went out. Check SoundCloud before you try again.',
  },
  masterBody: {
    id: 'app.sml.soundcloud.status.master.body',
    defaultMessage: 'The master of the song failed or is gone. Upload it again on the song page.',
  },
  reconnectBody: {
    id: 'app.sml.soundcloud.status.reconnect.body',
    defaultMessage: 'The login stopped working. Reconnect SoundCloud, then try again.',
  },
  chipWaiting: { id: 'app.sml.soundcloud.status.chip.waiting', defaultMessage: 'Waiting' },
  chipUploading: { id: 'app.sml.soundcloud.status.chip.uploading', defaultMessage: 'Uploading' },
  chipLive: { id: 'app.sml.soundcloud.status.chip.live', defaultMessage: 'Live' },
  chipPrivate: { id: 'app.sml.soundcloud.status.chip.private', defaultMessage: 'Private' },
  chipRemoved: { id: 'app.sml.soundcloud.status.chip.removed', defaultMessage: 'Removed' },
  chipFailed: { id: 'app.sml.soundcloud.status.chip.failed', defaultMessage: 'Failed' },
  chipSignedOut: { id: 'app.sml.soundcloud.status.chip.signedOut', defaultMessage: 'Signed out' },
  sharingPublic: { id: 'app.sml.soundcloud.status.sharing.public', defaultMessage: 'Public' },
  sharingPrivate: { id: 'app.sml.soundcloud.status.sharing.private', defaultMessage: 'Private' },
  changeTime: { id: 'app.sml.soundcloud.status.changeTime', defaultMessage: 'Change the time' },
  saveTime: { id: 'app.sml.soundcloud.status.saveTime', defaultMessage: 'Save the time' },
  cancelUpload: { id: 'app.sml.soundcloud.status.cancelUpload', defaultMessage: 'Cancel the upload' },
  openOnSoundCloud: { id: 'app.sml.soundcloud.status.open', defaultMessage: 'Open on SoundCloud' },
  copyLink: { id: 'app.sml.soundcloud.status.copyLink', defaultMessage: 'Copy link' },
  linkCopied: { id: 'app.sml.soundcloud.status.linkCopied', defaultMessage: 'Link copied' },
  uploadAgain: { id: 'app.sml.soundcloud.status.uploadAgain', defaultMessage: 'Upload again' },
  tryAgain: { id: 'app.sml.soundcloud.status.tryAgain', defaultMessage: 'Try again' },
  reconnect: { id: 'app.sml.soundcloud.status.reconnect', defaultMessage: 'Reconnect SoundCloud' },
});
